export default __webpack_public_path__ + "static/media/Festival_Dancers.44d6e791.jpg";